module.exports = __webpack_public_path__ + "img/go_live_shop.17ff08cd.svg";